import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV_ITEMS = [
  { id: "about-me-section", label: "Über mich" },
  { id: "product-intro-section", label: "So arbeite ich" },
  { id: "services-section", label: "Leistungen" },
  { id: "booking-section", label: "Termin" },
];

function scrollTo(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="sticky-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#F7F9FB]/85 backdrop-blur-md border-b border-[#1F2937]/10 text-[#1F2937]"
          : "bg-transparent text-[#F7F9FB]"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <button
          data-testid="logo-button"
          onClick={() => scrollTo("hero-section")}
          className="flex items-center gap-3 group"
        >
          <img
            src="/logo.png"
            alt="Alex Buchner Logo"
            className="h-11 w-11 object-contain rounded-lg"
          />
          <span className="font-display font-bold text-base sm:text-lg tracking-tight hidden sm:inline">
            Alex Buchner <span className="text-[#6FB04F]">Health</span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {NAV_ITEMS.map((it) => (
            <button
              key={it.id}
              data-testid={`nav-${it.id}`}
              onClick={() => scrollTo(it.id)}
              className={`text-sm font-medium transition-colors ${
                scrolled
                  ? "text-[#1F2937]/70 hover:text-[#1F2937]"
                  : "text-[#F7F9FB]/75 hover:text-[#F7F9FB]"
              }`}
            >
              {it.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="header-cta-button"
            onClick={() => scrollTo("booking-section")}
            className="btn-primary hidden sm:inline-flex items-center px-5 py-2.5 rounded-full text-sm font-semibold"
          >
            Erstgespräch sichern
          </button>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className={`md:hidden h-10 w-10 rounded-full flex items-center justify-center border ${
              scrolled ? "border-[#1F2937]/15" : "border-[#F7F9FB]/30"
            }`}
            aria-label="Menü"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-[#F7F9FB] border-t border-[#1F2937]/10"
        >
          <div className="px-6 py-5 flex flex-col gap-4">
            {NAV_ITEMS.map((it) => (
              <button
                key={it.id}
                data-testid={`mobile-nav-${it.id}`}
                onClick={() => {
                  setOpen(false);
                  scrollTo(it.id);
                }}
                className="text-left text-[#1F2937] font-medium"
              >
                {it.label}
              </button>
            ))}
            <button
              data-testid="mobile-cta-button"
              onClick={() => {
                setOpen(false);
                scrollTo("booking-section");
              }}
              className="btn-primary w-full px-5 py-3 rounded-full text-sm font-semibold mt-2"
            >
              Erstgespräch sichern
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
